import { BootstrapGridBreakpoints } from '@gn-audio/ui/constants/bootstrap-grid-breakpoints';
import { getClientWidth } from './get-client-width';

export function isTablet(): boolean {
  return getClientWidth() < BootstrapGridBreakpoints.Large;
}
